import * as yup from 'yup';
import useValidators from 'components/Form/validations/useValidators';
import { TFunction } from 'i18next';

const useValidationSchema = (
  t: TFunction,
  targetGridItems: {
    id?: string | undefined;
    label?: string | undefined;
  }[],
) => {
  const { required, min, integer, positive, number } = useValidators();

  const GridConfigurationFormSchema = yup.object().shape({
    name: required(yup.string()),
    priority: integer(positive(number(yup.number(), 'positiveWithoutZero'))),
    targetGrid: required(yup.string()),
    workPlaces: min(
      yup.array().transform((ids) => {
        return ids.filter((id: any) => {
          return id === 0 || id;
        });
      }),
      1,
      'selectMin1Workplace',
    ),
  });

  const formItems = [
    {
      type: 'input',
      name: 'name',
      label: t('name'),
      required: true,
    },
    {
      type: 'number',
      name: 'priority',
      label: t('priority'),
      required: true,
    },
    {
      type: 'select',
      name: 'targetGrid',
      label: t('targetGrid'),
      required: true,
      items: targetGridItems,
      disabled: targetGridItems.length === 1,
    },
  ];

  return { GridConfigurationFormSchema, formItems };
};

export default useValidationSchema;
